/**
 * Design Tokens: Colors
 * Centralized color definitions for consistent styling across the app
 */

export const colors = {
  // Primary palette
  primary: {
    main: '#5569ff',
    light: '#8b9dff',
    dark: '#3a4cb8',
    contrastText: '#ffffff',
  },

  // Secondary/Accent
  accent: {
    blue: '#33aaec',
    blueLight: '#66c4f2',
  },

  // Neutrals
  neutral: {
    white: '#ffffff',
    black: '#000000',
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#f2f5f9',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },

  // Semantic
  semantic: {
    success: '#44d600',
    warning: '#ffa319',
    error: '#ff1943',
    info: '#33c2ff',
  },

  // Table specific
  table: {
    headerBg: '#000000',
    headerText: '#ffffff',
    historyHeader: '#e0f2fc',
    rowOddBg: '#f2f5f9',
    rowEvenBg: '#ffffff',
    borderColor: '#e0e0e0',
    hoverBg: 'rgba(0, 0, 0, 0.04)',
  },

  // Background
  background: {
    default: '#f2f5f9',
    paper: '#ffffff',
    card: '#ffffff',
  },

  // Text
  text: {
    primary: '#223354',
    secondary: '#757575',
    disabled: '#9e9e9e',
  },
} as const;

export type Colors = typeof colors;
